import { getReflectionsUrl } from "../config/Config";
import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "./ServiceHelper";

export class ReflectionService {
  static getReflections = () => {
    return getRequest(getReflectionsUrl()).then((reflections) => {
      return reflections;
    });
  };

  static getReflectionsForContext = (contextId) => {
    return getRequest(getReflectionsUrl() + "/" + contextId);
  };

  static addReflection = (termId, text, author, cycle, course) => {
    const param = {
      termId: termId,
      text: text,
      author: author,
      cycle: cycle,
      course: course,
    };
    return postRequest(getReflectionsUrl(), param);
  };

  static addReflectionForContext = (text, author, contextId) => {
    const param = { text: text, author: author };
    return postRequest(getReflectionsUrl() + "/" + contextId, param);
  };

  static deleteReflection = (reflectionId) => {
    return deleteRequest(getReflectionsUrl() + "/delete/" + reflectionId);
  };

  static updateReflection = (reflection) => {
    return putRequest(
      getReflectionsUrl() + "/update/" + reflection.id,
      reflection
    );
  };
}
